import qq from 'fine-uploader/lib/traditional';
import common from '../common/common';
import translateService from '../common/translateService';

export default {
    setup: ({
        id,
        onComplete,
        onDeleteComplete,
        onSubmitDelete,
        sizeLimit,
    }) => {
        var imageUploader = new qq.FineUploader({
            element: document.getElementById(id),
            template: 'qq-template-gallery',
            text: {},
            request: {
                endpoint: common.getSiteUrl() + '/upload/uploadfile',
            },
            messages: {
                typeError: translateService.get(
                    'reviewImages.messages.typeError'
                ),
                sizeError: translateService.get(
                    'reviewImages.messages.sizeError'
                ),
                emptyError: translateService.get(
                    'reviewImages.messages.emptyError'
                ),
                tooManyItemsError: translateService.get(
                    'reviewImages.messages.tooManyItemsError'
                ),
                // other messages can go here as well ...
            },
            validation: {
                allowedExtensions: ['jpeg', 'jpg', 'png', 'bmp'],
                itemLimit: 3,
                sizeLimit: sizeLimit || 3000000, // 3MB
            },
            deleteFile: {
                enabled: true,
                forceConfirm: true,
                confirmMessage: translateService.get(
                    'reviewImages.deleteFile.confirmMessage'
                ),
                endpoint: common.getSiteUrl() + '/image/delete',
            },
            callbacks: {
                onComplete,
                onDeleteComplete,
                onSubmitDelete,
            },
        });

        return imageUploader;
    },
};
